import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
const mockUsers = [{
  id: 1,
  name: 'Marcus Chen',
  email: 'marcus@chengroup.com',
  shortUrl: '/marcuschen',
  status: 'Active',
  role: 'Admin'
}, {
  id: 2,
  name: 'Krystle Copeland',
  email: 'krystle@eaves.pro',
  shortUrl: '/krystlecopeland',
  status: 'Active',
  role: 'Admin'
}, {
  id: 3,
  name: 'Sarah Kim',
  email: 'sarah.kim@compass.com',
  shortUrl: '/sarahkim',
  status: 'Active',
  role: 'Agent'
}, {
  id: 4,
  name: 'David Park',
  email: 'david.park@sothebys.com',
  shortUrl: '/davidpark',
  status: 'Pending',
  role: 'Agent'
}];
export function AdminUsers() {
  return <div className="p-8 max-w-6xl mx-auto" data-id="element-399">
      <div className="mb-8" data-id="element-400">
        <h1 className="text-3xl font-serif font-semibold text-brand-dark mb-2" data-id="element-401">
          All Users
        </h1>
        <p className="text-sm text-brand-muted" data-id="element-402">
          Manage registered agent profiles
        </p>
      </div>

      <div className="bg-white rounded-2xl border border-brand-light shadow-sm overflow-hidden" data-id="element-403">
        <div className="overflow-x-auto" data-id="element-404">
          <table className="w-full text-left text-sm" data-id="element-405">
            <thead className="bg-brand-offwhite border-b border-brand-light text-brand-muted" data-id="element-406">
              <tr data-id="element-407">
                <th className="px-6 py-4 font-medium" data-id="element-408">Name</th>
                <th className="px-6 py-4 font-medium" data-id="element-409">Email</th>
                <th className="px-6 py-4 font-medium" data-id="element-410">Short URL</th>
                <th className="px-6 py-4 font-medium" data-id="element-411">Status</th>
                <th className="px-6 py-4 font-medium" data-id="element-412">Role</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-413">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-brand-light" data-id="element-414">
              {mockUsers.map(user => <tr key={user.id} className="hover:bg-brand-offwhite/50 transition-colors" data-id="element-415">
                  <td className="px-6 py-4 font-medium text-brand-dark" data-id="element-416">
                    {user.name}
                  </td>
                  <td className="px-6 py-4 text-brand-muted" data-id="element-417">{user.email}</td>
                  <td className="px-6 py-4 font-mono text-brand-muted" data-id="element-418">
                    {user.shortUrl}
                  </td>
                  <td className="px-6 py-4" data-id="element-419">
                    <span className={`inline-flex items-center px-2 py-1 rounded-md text-[11px] font-medium uppercase tracking-wider ${user.status === 'Active' ? 'bg-emerald-50 text-emerald-700 border border-emerald-200' : 'bg-amber-50 text-amber-700 border border-amber-200'}`} data-id="element-420">
                      {user.status}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-421">
                    <span className={`inline-flex items-center px-2 py-1 rounded-md text-[11px] font-medium uppercase tracking-wider ${user.role === 'Admin' ? 'bg-brand-forest text-white' : 'bg-brand-sage text-brand-forest border border-brand-forest/20'}`} data-id="element-422">
                      {user.role}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-423">
                    <div className="flex items-center justify-end gap-3" data-id="element-424">
                      <Link to="/admin/edit" className="text-brand-forest hover:text-brand-dark font-medium transition-colors" data-id="element-425">
                        Edit
                      </Link>
                      <a href={user.shortUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-brand-muted hover:text-brand-dark transition-colors" data-id="element-426">
                        View <ExternalLink size={14} data-id="element-427" />
                      </a>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}